import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Notifications } from 'src/components/Notifications';
import { ROUTE } from 'src/constants/routes';
import { AppHooks } from 'src/containers/AppHooks';
import { AppNavbar } from 'src/containers/AppNavbar';
import { BrowserAuthFailedDialog } from 'src/containers/BrowserAuthFailedDialog/BrowserAuthFailedDialog';
import { SignInDialog } from 'src/containers/ConnectionMenu/SignInDialog';
import { CreateProjectOverlay } from 'src/containers/CreateProjectOverlay/CreateProjectOverlay';
import { Home } from 'src/containers/Home/Home';
import { ProjectContextProvider } from 'src/containers/Project/ProjectContextProvider';
import { ProjectDrawers } from 'src/containers/Project/ProjectDrawers';
import { ProjectOverlays } from 'src/containers/Project/ProjectOverlays';
import { ProjectRedirectWrapper } from 'src/containers/Project/ProjectRedirectWrapper';
import { ProjectRoutes } from 'src/containers/Project/ProjectRoutes';
import { ProjectNavbar } from 'src/containers/ProjectNavbar/ProjectNavbar';
import { VoiceboxFooter } from 'src/containers/Voicebox/VoiceboxFooter';

const AppOverlays: React.VFC = () => (
  <>
    <CreateProjectOverlay />
    <BrowserAuthFailedDialog />
    <SignInDialog />
    <Notifications />
  </>
);

export const App: React.VFC = () => {
  return (
    <>
      <AppHooks />
      <Switch>
        <Route exact path={ROUTE.HOME}>
          <div className="sd-container">
            <div className="sd-container-body">
              <AppNavbar />
              <Home />
            </div>
          </div>
          <AppOverlays />
        </Route>
        <Route path={ROUTE.PROJECT}>
          <ProjectContextProvider>
            <div className="sd-container">
              <ProjectNavbar />
              <div className="sd-container-body">
                <ProjectRedirectWrapper>
                  <ProjectRoutes />
                  <ProjectDrawers />
                </ProjectRedirectWrapper>
              </div>
              <div className="sd-container-footer">
                <VoiceboxFooter />
              </div>
            </div>
            <ProjectOverlays />
            <AppOverlays />
          </ProjectContextProvider>
        </Route>
        <Redirect to={ROUTE.HOME} />
      </Switch>
    </>
  );
};
